import { IonCard, IonItem, IonProgressBar } from "@ionic/react";
import { useEffect, useState } from "react";

import CircleButton from "@components/buttons/CircleButton";
import styles from "@components/fields/AttachmentPreview.module.css";
import IconBase from "@components/text/IconBase";
import { UploadWithFile } from "@typing/Models";
import { directUpload } from "@utils/fileUtils";
import { truncate } from "@utils/stringUtils";

type Props = {
  onComplete: () => void;
  onDelete: () => void;
  uploadWithFile: UploadWithFile;
};

const AttachmentPreview = ({ onComplete, onDelete, uploadWithFile }: Props) => {
  const { file, upload } = uploadWithFile;
  const [progress, setProgress] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    directUpload({
      file,
      jsonEncodedHeaders: upload.headers,
      onProgress: percentComplete => {
        setProgress(percentComplete);
      },
      url: upload.url
    })
      .then(() => {
        onComplete();
      })
      .finally(() => {
        setLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <IonCard className={styles.preview} color="gray-50">
      <IonItem color="gray-50" lines="none">
        {loading ? (
          <IconBase color="dark" icon="spinner" slot="start" />
        ) : (
          <IconBase color="success" icon="checkmark" slot="start" />
        )}
        <div className={styles.filename}>
          {truncate(file.name, 50)}
          {loading && <IonProgressBar className={styles.progressBar} color="primary-300" value={progress / 100.0} />}
        </div>
        <CircleButton color="gray-200" icon="xmark" onClick={onDelete} slot="end" />
      </IonItem>
    </IonCard>
  );
};

export default AttachmentPreview;
